"use strict";
(self["webpackChunkpop_and_bottle"] = self["webpackChunkpop_and_bottle"] || []).push([[587],{

/***/ 587:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ productImageSlider)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var swiper_bundle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(732);



function productImageSlider({ wrapper }) {
  ;(function init() {
    const thumbnailSlider = new swiper_bundle__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A("[data-hook=thumb-slider]", {
      spaceBetween: 21,
      slidesPerView: 4,
      freeMode: true,
    //   watchSlidesProgress: true,
      direction: 'vertical'
    });

    const mainSlider = new swiper_bundle__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A("[data-hook=main-slider]", {
      slidesPerView: 1,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        bulletActiveClass: 'tw-on',
        bulletClass: "tw-block tw-w-2 lg:tw-w-3 tw-aspect-square tw-rounded-full tw-bg-transparent on:tw-bg-black tw-border tw-border-solid tw-border-black tw-mx-1 lg:tw-mx-1.5 hover:tw-cursor-pointer",
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: thumbnailSlider,
      },
    });
  })()
}

/***/ })

}]);